import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Slide,
} from '@mui/material';
import { ModalSuccessIconIcon } from '@app/icons';
import React, { PropsWithChildren } from 'react';
import { TransitionProps } from '@mui/material/transitions';

interface IProps {
  open: boolean;
  onConfirm: () => any;
  onClose: () => any;
  onCancel: () => any;
  title?: string;
  content?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const ConfirmDialog: React.FC<PropsWithChildren<IProps>> = ({
  open,
  onConfirm,
  onClose,
  onCancel,
  title,
  content,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  children,
}) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { p: 6, minWidth: '400px' },
      }}
      TransitionComponent={Transition}
      onClose={onClose}
    >
      <Box display="flex" justifyContent="flex-end">
        <IconButton sx={{ mr: '-8px', mt: '-8px' }} onClick={onClose}>
          <i className="ri-close-fill" style={{ fontSize: 24 }} />
        </IconButton>
      </Box>
      <Box display="flex" justifyContent="center" my={3}>
        <ModalSuccessIconIcon />
      </Box>
      {title && <DialogTitle sx={{ paddingTop: '16px' }}>{title}</DialogTitle>}
      <DialogContent>
        {content && (
          <DialogContentText
            align="center"
            sx={{
              mt: 2,
              fontWeight: '500',
              fontSize: '16px',
              lineHeight: '20px',
            }}
          >
            {content}
          </DialogContentText>
        )}
        {children && (
          <Box display="flex" mt={2}>
            {children}
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          p: 0,
          pt: 6,
          rowGap: 3,
        }}
      >
        <Button
          color="secondary"
          size="large"
          sx={{
            display: 'flex',
            flexGrow: 1,
          }}
          variant="contained"
          onClick={onCancel}
        >
          {cancelButtonText}
        </Button>
        <Button
          autoFocus
          size="large"
          sx={{
            display: 'flex',
            flexGrow: 1,
          }}
          variant="contained"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
